import { CompanyContentHealth } from '../../types/contentCompletion';

/**
 * Ordered backfill source URLs: RSS first, then press-release page, then legacy feed.
 * Callers should try the next candidate when the preferred source returns no results.
 */
export const resolveSourceCandidates = (company: CompanyContentHealth): string[] => {
  const urls = [
    company.feed_news_rss?.trim(),
    company.press_release_url?.trim(),
    company.feed_press_release?.trim(),
  ].filter((url): url is string => Boolean(url));

  return [...new Set(urls)];
};

/** Preferred press-release source URL for backfill preview (matches CompanyDetailDrawer). */
export const resolveDefaultSourceUrl = (company: CompanyContentHealth): string =>
  resolveSourceCandidates(company)[0] ?? '';
